import { Config } from '@genial/config';

import { DocumentsCenterAccordionList } from './components/DocumentsCenterAccordionList';
import { DocumentsCenterList } from './components/DocumentsCenterList';

export const documentsCenterTabs = {
  person: { label: 'Pessoa Física', component: DocumentsCenterList },
  company: { label: 'Pessoa Jurídica', component: DocumentsCenterAccordionList },
  minor: { label: 'Menor de Idade', component: DocumentsCenterList },
};

export type multipleTermsDescription = {
  title: string;
  children?: multipleTermsDescription;
}[];

export type DocumentsCenterTabs = keyof typeof documentsCenterTabs;
export type DocumentsCenterLinkList = {
  title: string;
  titleNote?: string;
  url?: string;
  description: string[];
  fileName?: string;
  children?: multipleTermsDescription;
}[];

export const DocumentsCenterLinksByTab: Record<DocumentsCenterTabs, DocumentsCenterLinkList> = {
  person: [
    {
      title: 'Ficha Cadastral',
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/pf/GI-Ficha-Cadastral-PF.pdf`,
      description: ['Ficha Cadastral de Pessoa Física'],
    },
    {
      title: 'Termo de Adesão de Contrato de Intermediação',
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/pf/GI-Termo-de-Adesao-ao-Contrato-de-Intermediacao.pdf`,
      description: [
        'Operações nos mercados administrados pela BM&FBOVESPA S.A - bolsa de valores, mercadorias e futuros e nos mercados de balcão, de prestação de serviços de custódia de ativos e outras avenças',
      ],
    },
    {
      title: 'Questionário de Suitability',
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/pf/GI-Questionario-Suitability-PF.pdf`,
      description: [
        'O questionário a seguir faz parte do processo de adequação (Suitability) do perfil de investidor',
      ],
    },
    {
      title: 'Declaração de Investidor',
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/pf/GI-DeclaracaoInvestidor-Qualificado-Profissional.pdf`,
      description: ['Declaração de Condição de Investidor Qualificado/Profissional'],
    },
    {
      title: 'Termo de Adesão',
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/pf/GI-Termo-Adesao.pdf`,
      description: ['Termo de Adesão e Ciência de Risco'],
    },
    {
      title: 'Contrato Registrado em Cartório (para ciência)',
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/pf/GI-Contrato-Registrado-em-Cartorio.pdf`,
      description: ['Contrato de intermediação de Operações na B3 - Brasil, Bolsa, Balcão'],
    },
    {
      title: 'Formulário de KYC',
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/pf/GI-Formulario-KYC.pdf`,
      description: [
        'Documento CONFIDENCIAL de preenchimento OBRIGATÓRIO e de USO EXCLUSIVO INTERNO',
      ],
    },
  ],
  company: [
    {
      title: 'Abertura de conta manual - Banco e Corretora',
      description: [],
      fileName: 'manualAccountOpeningBrokerageBank',
      children: [
        {
          title: 'Documentação para o Assessor',
          children: [
            {
              title: 'Guia de orientação para o assessor',
            },
            {
              title: 'Formulário de KYC - Corretora',
            },
            {
              title: 'Formulário de KYC - Banco',
            },
          ],
        },
        {
          title: 'Documentação obrigatória do Cliente',
          children: [
            {
              title: 'Ficha cadastral PJ - 2025.2026 (corretora - completa)',
            },
            {
              title: 'Termo de adesão ao Contrato de Intermediação',
            },
            {
              title: 'Cartão de Assinaturas PJ',
            },
            {
              title: 'Termo Abertura Conta Corrente - PJ',
            },
            {
              title: 'Formulário complementar',
            },
            {
              title: 'Prospecto de informações essenciais de C.C',
            },
            {
              title: 'Questionário Suitability Unificado',
            },
          ],
        },
        {
          title: 'Documentação opcional do Cliente',
          children: [
            {
              title: 'Termo de Renda Fixa - PT',
            },
            {
              title: 'Termo de Adesão Fundos',
            },
            {
              title: 'Termo de Adesão de Clubes',
            },
            {
              title: 'Termo de Ciência Assessor de Investimento',
            },
            {
              title: 'Contrato de Intermediação BEE4',
            },
            {
              title: 'Declaração de Condição de Investidor Qualificado ou Profissional',
            },
            {
              title: 'Carta Emissores de Ordens - Corretoras',
            },
            {
              title: 'Declaração de Empresa Sem Faturamento',
            },
            {
              title: 'Faturamento médio mensal (12 meses)',
            },
          ],
        },
      ],
    },
    {
      title: 'Abertura de conta manual - Banco',
      description: [],
      fileName: 'manualAccountOpeningBank',
      children: [
        {
          title: 'Documentação para o Assessor',
          children: [
            {
              title: 'Guia de orientação para o assessor',
            },
            {
              title: 'Formulário de KYC - Banco',
            },
          ],
        },
        {
          title: 'Documentação obrigatória do cliente',
          children: [
            {
              title: 'Ficha cadastral PJ - 2025.2026 (corretora - completa)',
            },
            {
              title: 'Termo de adesão ao Contrato de Intermediação',
            },
            {
              title: 'Cartão de Assinaturas PJ',
            },
            {
              title: 'Formulário complementar',
            },
            {
              title: 'Prospecto de informações essenciais de C.C',
            },
            {
              title: 'Questionário Suitability Unificado',
            },
          ],
        },
        {
          title: 'Documentação opcional do cliente',
          children: [
            {
              title: 'Declaração de Condição de Investidor Qualificado ou Profissional',
            },
            {
              title: 'Declaração de Empresa Sem Faturamento',
            },
            {
              title: 'Faturamento médio mensal (12 meses)',
            },
          ],
        },
      ],
    },
    {
      title: 'Abertura de conta manual - Corretora',
      description: [],
      fileName: 'manualAccountOpeningBrokerage',
      children: [
        {
          title: 'Documentação para o Assessor',
          children: [
            {
              title: 'Guia de orientação para o assessor',
            },
            {
              title: 'Formulário de KYC - Corretora',
            },
          ],
        },
        {
          title: 'Documentação obrigatória do Cliente',
          children: [
            {
              title: 'Ficha cadastral PJ - 2025.2026 (corretora - completa)',
            },
            {
              title: 'Termo de adesão ao Contrato de Intermediação',
            },
            {
              title: 'Questionário Suitability Unificado',
            },
          ],
        },
        {
          title: 'Documentação opcional do Cliente',
          children: [
            {
              title: 'Termo de Renda Fixa - PT',
            },
            {
              title: 'Termo de Adesão Fundos',
            },
            {
              title: 'Termo de Adesão de Clubes',
            },
            {
              title: 'Termo de Ciência Assessor de Investimento',
            },
            {
              title: 'Contrato de Intermediação BEE4',
            },
            {
              title: 'Declaração de Condição de Investidor Qualificado ou Profissional',
            },
            {
              title: 'Carta Emissores de Ordens - Corretoras',
            },
            {
              title: 'Declaração de Empresa Sem Faturamento',
            },
            {
              title: 'Faturamento médio mensal (12 meses)',
            },
          ],
        },
      ],
    },
    {
      title: 'Abertura de conta digital - Banco e Corretora',
      description: [],
      fileName: 'digitalAccountOpeningBrokerageBank',
      children: [
        {
          title: 'Documentação para o Assessor',
          children: [
            {
              title: 'Guia de orientação para o assessor',
            },
            {
              title: 'Formulário de KYC - Banco',
            },
            {
              title: 'Formulário de KYC - Corretora',
            },
          ],
        },
      ],
    },
  ],
  minor: [
    {
      title: 'Ficha Cadastral',
      description: ['Ficha Cadastral de Pessoa Física'],
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/menor/GI-Ficha-Cadastral-Menor.pdf`,
    },
    {
      title: 'Termo de Adesão ao Contrato de Intermediação',
      description: [
        'Operações nos mercados admnistrados pela BM&FBOVESPA S.A - bolsa de valores, mecadorias e futuros e nos mercados de balcão, de prestação de serviços de custódia de ativos e outras avenças',
      ],
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/menor/GI-Termo-de-Adesao-ao-Contrato-Intermediacao.pdf`,
    },
    {
      title: 'Questionário de Suitability',
      description: [
        'O questionário a seguir faz parte do processo de adequação (Suitability) do perfil do investidor',
      ],
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/menor/GI-Questionario-Suitability-Menor.pdf`,
    },
    {
      title: 'Declaração de Investidor',
      description: ['Declaração da Condição de Investidor Qualificado/Profissional'],
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/menor/GI-Declaracao-Investidor-Qualificado-Profissional.pdf`,
    },
    {
      title: 'Termo de Adesão a Fundos',
      description: ['Termo de Adesão e Ciência de Risco'],
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/menor/GI-Termo-de-Adesao-Fundos.pdf`,
    },
    {
      title: 'Ficha Complementar',
      description: ['Informações Complementares'],
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/menor/GI-Ficha-Complementar.pdf`,
    },
    {
      title: 'Formulário de KYC',
      description: [
        'Documento CONFIDENCIAL, de preenchimento OBRIGATÓRIO e de USO EXCLUSIVO INTERNO',
      ],
      url: `${Config.GenialCdnUrl}Extranet/kitcadastral/menor/GI-Formulario-KYC.pdf`,
    },
  ],
};
